'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

require('@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css');

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapboxGlGeocoder = require('@mapbox/mapbox-gl-geocoder');

var _mapboxGlGeocoder2 = _interopRequireDefault(_mapboxGlGeocoder);

var _reactMapGl = require('react-map-gl');

var _viewportMercatorProject = require('viewport-mercator-project');

var _viewportMercatorProject2 = _interopRequireDefault(_viewportMercatorProject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var VALID_POSITIONS = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];

function fitBounds(bounds, viewport) {
  return new _viewportMercatorProject2.default(viewport).fitBounds(bounds);
}

function getAccessToken() {
  var accessToken = null;

  if (typeof window !== 'undefined' && window.location) {
    var match = window.location.search.match(/access_token=([^&/]*)/);
    accessToken = match && match[1];
  }

  if (!accessToken && typeof process !== 'undefined') {
    // Note: This depends on bundler plugins (e.g. webpack) inmporting environment correctly
    accessToken = accessToken || process.env.MapboxAccessToken; // eslint-disable-line
  }

  return accessToken || null;
}

var Geocoder = function (_Component) {
  _inherits(Geocoder, _Component);

  function Geocoder() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Geocoder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Geocoder.__proto__ || Object.getPrototypeOf(Geocoder)).call.apply(_ref, [this].concat(args))), _this), _this.geocoder = null, _this.cachedInputValue = '', _this.initializeGeocoder = function () {
      var mapboxMap = _this.getMapboxMap();

      var containerNode = _this.getContainerNode();

      var _this$props = _this.props,
          mapboxApiAccessToken = _this$props.mapboxApiAccessToken,
          inputValue = _this$props.inputValue,
          zoom = _this$props.zoom,
          placeholder = _this$props.placeholder,
          proximity = _this$props.proximity,
          trackProximity = _this$props.trackProximity,
          bbox = _this$props.bbox,
          types = _this$props.types,
          country = _this$props.country,
          minLength = _this$props.minLength,
          limit = _this$props.limit,
          language = _this$props.language,
          filter = _this$props.filter,
          localGeocoder = _this$props.localGeocoder,
          options = _this$props.options,
          onInit = _this$props.onInit,
          position = _this$props.position;
      _this.geocoder = new _mapboxGlGeocoder2.default(_extends({
        accessToken: mapboxApiAccessToken,
        zoom: zoom,
        flyTo: false,
        placeholder: placeholder,
        proximity: proximity,
        trackProximity: trackProximity,
        bbox: bbox,
        types: types,
        country: country,
        minLength: minLength,
        limit: limit,
        language: language,
        filter: filter,
        localGeocoder: localGeocoder
      }, options));

      _this.subscribeEvents();

      if (containerNode) {
        containerNode.appendChild(_this.geocoder.onAdd(mapboxMap));
      } else {
        mapboxMap.addControl(_this.geocoder, VALID_POSITIONS.find(function (_position) {
          return position === _position;
        }));
      }

      if (inputValue !== undefined && inputValue !== null) {
        _this.cachedInputValue = inputValue;
      }

      _this.geocoder.setInput(_this.cachedInputValue);

      onInit(_this.geocoder);
    }, _this.getMapboxMap = function () {
      var mapRef = _this.props.mapRef;
      return mapRef && mapRef.current && mapRef.current.getMap() || null;
    }, _this.getContainerNode = function () {
      var containerRef = _this.props.containerRef;
      return containerRef && containerRef.current || null;
    }, _this.subscribeEvents = function () {
      _this.geocoder.on('clear', _this.handleClear);

      _this.geocoder.on('loading', _this.handleLoading);

      _this.geocoder.on('results', _this.handleResults);

      _this.geocoder.on('result', _this.handleResult);

      _this.geocoder.on('error', _this.handleError);
    }, _this.unsubscribeEvents = function () {
      _this.geocoder.off('clear', _this.handleClear);

      _this.geocoder.off('loading', _this.handleLoading);

      _this.geocoder.off('results', _this.handleResults);

      _this.geocoder.off('result', _this.handleResult);

      _this.geocoder.off('error', _this.handleError);
    }, _this.removeGeocoder = function () {
      var mapboxMap = _this.getMapboxMap();

      _this.unsubscribeEvents();

      if (mapboxMap && mapboxMap.removeControl) {
        _this.getMapboxMap().removeControl(_this.geocoder);
      }

      _this.geocoder = null;
    }, _this.handleClear = function () {
      _this.cachedInputValue = '';

      _this.props.onClear();
    }, _this.handleLoading = function (event) {
      _this.props.onLoading(event);
    }, _this.handleResults = function (event) {
      _this.props.onResults(event);
    }, _this.handleResult = function (event) {
      var result = event.result;
      var _this$props2 = _this.props,
          mapRef = _this$props2.mapRef,
          onViewportChange = _this$props2.onViewportChange,
          onResult = _this$props2.onResult;
      var id = result.id,
          bbox = result.bbox,
          center = result.center;

      var _center = _slicedToArray(center, 2),
          longitude = _center[0],
          latitude = _center[1];

      var bboxExceptions = {
        'country.3148': {
          name: 'France',
          bbox: [[-4.59235, 41.380007], [9.560016, 51.148506]]
        },
        'country.3145': {
          name: 'United States',
          bbox: [[-171.791111, 18.91619], [-66.96466, 71.357764]]
        },
        'country.330': {
          name: 'Russia',
          bbox: [[19.66064, 41.151416], [190.10042, 81.2504]]
        },
        'country.3179': {
          name: 'Canada',
          bbox: [[-140.99778, 41.675105], [-52.648099, 83.23324]]
        }
      };
      var width = mapRef.current.props.width;
      var height = mapRef.current.props.height;
      var zoom = _this.geocoder.options.zoom;

      if (!bboxExceptions[id] && bbox) {
        zoom = fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
          width: width,
          height: height
        }).zoom;
      } else if (bboxExceptions[id]) {
        zoom = fitBounds(bboxExceptions[id].bbox, {
          width: width,
          height: height
        }).zoom;
      }

      onViewportChange({
        longitude: longitude,
        latitude: latitude,
        zoom: zoom,
        transitionInterpolator: new _reactMapGl.FlyToInterpolator(),
        transitionDuration: 3000
      });
      onResult(event);

      if (result && result.place_name) {
        _this.cachedInputValue = result.place_name;
      }
    }, _this.handleError = function (event) {
      _this.props.onError(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Geocoder, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initializeGeocoder();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeGeocoder();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.removeGeocoder();
      this.initializeGeocoder();
    }
  }, {
    key: 'getGeocoder',
    value: function getGeocoder() {
      return this.geocoder;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Geocoder;
}(_react.Component);

Geocoder.propTypes = {
  mapRef: _propTypes2.default.object.isRequired,
  containerRef: _propTypes2.default.object,
  onViewportChange: _propTypes2.default.func,
  mapboxApiAccessToken: _propTypes2.default.string,
  inputValue: _propTypes2.default.string,
  zoom: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  proximity: _propTypes2.default.object,
  trackProximity: _propTypes2.default.bool,
  bbox: _propTypes2.default.array,
  types: _propTypes2.default.string,
  country: _propTypes2.default.string,
  minLength: _propTypes2.default.number,
  limit: _propTypes2.default.number,
  language: _propTypes2.default.string,
  filter: _propTypes2.default.func,
  localGeocoder: _propTypes2.default.func,
  position: _propTypes2.default.oneOf(VALID_POSITIONS),
  onInit: _propTypes2.default.func,
  onClear: _propTypes2.default.func,
  onLoading: _propTypes2.default.func,
  onResults: _propTypes2.default.func,
  onResult: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  options: _propTypes2.default.object // deprecated and will be removed in v2

};
Geocoder.defaultProps = {
  onViewportChange: function onViewportChange() {},
  mapboxApiAccessToken: getAccessToken(),
  zoom: 16,
  placeholder: 'Search',
  trackProximity: false,
  minLength: 2,
  limit: 5,
  position: 'top-right',
  onInit: function onInit() {},
  onClear: function onClear() {},
  onLoading: function onLoading() {},
  onResults: function onResults() {},
  onResult: function onResult() {},
  onError: function onError() {}
};
exports.default = Geocoder;